/* Coziness: Info-Popup fuer interne Seiten
   ================================================================
   Ein Link mit [data-cz-popup] oeffnet die verlinkte Seite in einem Popup,
   der Kunde bleibt auf der Produktseite bzw. im Warenkorb (AGB und
   Widerrufsrecht im Drawer, Skript dort ebenfalls eingebunden). Basis ist Prestiges x-modal: am
   Rechner mittig, am Handy als Bottom-Sheet; Fokus ins Popup, ESC, Klick
   daneben, Schliessen-Knopf, Scroll-Sperre und Fokus-Rueckgabe bringt es mit.
   Inhalt sind die Inhalts-Sections der verlinkten (lokalisierten) Seite,
   ohne Skripte und ohne App-Bereich; einmal geladen bleibt er im Speicher.
   Ohne JS bleibt es ein normaler Link; schlaegt das Laden fehl, wird ganz
   normal zur Seite navigiert. */

(function () {
    'use strict';
    if (window.__czInfoPopup) return;
    window.__czInfoPopup = true;

    var script = document.currentScript;
    var LOADING = (script && script.getAttribute('data-loading-label')) || '';
    var cache = {};
    /* Titel bereits geladener Seiten ueberleben den Seitenwechsel (Session),
       damit der Kopf beim ersten Laden auf der naechsten Produktseite nicht
       leer bleibt */
    var TITLES_KEY = 'cz-info-popup-titles';
    /* Seiten mit eigenem Hero (Ruecksendung, Versandkosten, Sendung verfolgen) */
    var HERO_TITLE = '.cz-rt__title, .cz-sc__title, .cz-st-pg__title';
    var HERO_EYEBROW = '.cz-rt__eyebrow, .cz-sc__eyebrow, .cz-st-pg__eyebrow';
    /* Knoepfe im Hero, die im Popup nichts verloren haben: auf der
       Versandkosten-Seite "Sendung verfolgen" / "Support kontaktieren", auf
       der Ruecksendeseite deren Hero-Knoepfe - wer vor dem Kauf Versand oder
       Rueckgabe nachschaut, hat noch nichts bestellt */
    var HERO_ACTIONS = '.cz-sc__ctas, .cz-rt__hero-actions';
    var modal = null;
    var titleEl = null;
    var bodyEl = null;
    var current = null;

    function ensureModal() {
        if (modal) return;
        modal = document.createElement('x-modal');
        modal.id = 'cz-info-popup';
        modal.className = 'modal modal--lg color-scheme color-scheme--dialog cz-info-popup';
        titleEl = document.createElement('span');
        titleEl.className = 'h5';
        titleEl.slot = 'header';
        titleEl.id = 'cz-info-popup-title';
        bodyEl = document.createElement('div');
        bodyEl.className = 'cz-info-popup__body';
        modal.setAttribute('aria-labelledby', titleEl.id);
        /* Fokus beim Oeffnen auf den Titel (das Popup hat kein Eingabefeld).
           Bewusst NICHT tabindex am x-modal selbst: das nimmt den ganzen
           Shadow-Inhalt samt Schliessen-Knopf aus der Tab-Folge. */
        titleEl.tabIndex = -1;
        modal.setAttribute('initial-focus', '#' + titleEl.id);
        modal.appendChild(titleEl);
        modal.appendChild(bodyEl);
        document.body.appendChild(modal);
        /* Popup zu: ein noch laufendes Laden darf weder rendern noch wegleiten */
        modal.addEventListener('dialog:before-hide', function () { current = null; });
        /* Prestige blendet das Modal am Rechner ueber die opacity des Hosts
           ein (0,2 s); solange die < 1 ist, rendert das Glas (backdrop-filter)
           nicht und das Panel waere kurz durchsichtig. Deshalb sofort fertig.
           Am Handy animiert Prestige nur Overlay und Sheet, nicht den Host. */
        function settle() {
            queueMicrotask(function () {
                modal.getAnimations().forEach(function (a) { a.finish(); });
            });
        }
        modal.addEventListener('dialog:before-show', settle);
        modal.addEventListener('dialog:before-hide', settle);
        /* Inhalt beim Oeffnen oben zeigen. Erst hier wirkt scrollTop: Prestige
           setzt display:block unmittelbar vor diesem Event, solange das Modal
           zu ist (display:none), wird der Wert ignoriert und am Handy stand
           waehrend des Hochfahrens noch die alte Scroll-Position. */
        modal.addEventListener('dialog:before-show', function () { bodyEl.scrollTop = 0; });
    }

    function readTitles() {
        try {
            var t = JSON.parse(window.sessionStorage.getItem(TITLES_KEY));
            return t && typeof t === 'object' ? t : {};
        } catch (e) {
            return {};
        }
    }

    function storeTitle(url, title) {
        if (!title) return;
        try {
            var t = readTitles();
            t[url] = title;
            window.sessionStorage.setItem(TITLES_KEY, JSON.stringify(t));
        } catch (e) { /* ohne Speicher bleibt der Kopf beim ersten Laden leer */ }
    }

    function showLoading() {
        var box = document.createElement('div');
        box.className = 'cz-info-popup__loading';
        box.setAttribute('role', 'status');
        var label = document.createElement('span');
        label.className = 'sr-only';
        label.textContent = LOADING;
        box.appendChild(label);
        bodyEl.setAttribute('aria-busy', 'true');
        bodyEl.replaceChildren(box);
    }

    function render(data) {
        titleEl.textContent = data.title;
        bodyEl.removeAttribute('aria-busy');
        bodyEl.innerHTML = data.html;
        bodyEl.scrollTop = 0;
    }

    /* Seitentitel aus og:title: Entities aufloesen (auch doppelt kodierte
       wie "&amp;amp;") und den Shop-Namen am Ende abschneiden */
    function cleanTitle(s) {
        var ta = document.createElement('textarea');
        ta.innerHTML = s || '';
        return ta.value.replace(/\s*[|\u2013\u2014-]\s*Coziness\s*$/i, '').trim();
    }

    /* Holt die Seite und behaelt nur die Sections der Vorlage (der Footer
       liegt bei Prestige ebenfalls in <main>, die App-Section ist leer). */
    function load(url) {
        return fetch(url, { credentials: 'same-origin' }).then(function (res) {
            if (!res.ok) throw new Error('HTTP ' + res.status);
            return res.text();
        }).then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var main = doc.getElementById('main') || doc.querySelector('main');
            if (!main) throw new Error('kein main');
            var sections = Array.prototype.filter.call(main.children, function (el) {
                return /^shopify-section-template--/.test(el.id) && !el.classList.contains('shopify-section--apps');
            });
            var wrap = doc.createElement('div');
            /* Shopify-Richtlinien (AGB, Widerruf/Rueckerstattung) haben keine
               Sections: Titel in den Kopf des Popups, Text als Inhalt; eine
               Ueberschrift am Textanfang, die den Titel wiederholt, faellt weg */
            var policy = !sections.length && main.querySelector('.shopify-policy__container');
            if (policy) {
                var pTitle = policy.querySelector('.shopify-policy__title');
                var pText = pTitle ? pTitle.textContent.trim() : '';
                if (pTitle) pTitle.remove();
                var pBody = policy.querySelector('.shopify-policy__body .rte') || policy;
                var lead = pBody.firstElementChild;
                if (lead && pText && lead.textContent.trim() === pText) lead.remove();
                wrap.appendChild(policy);
                wrap.querySelectorAll('script, noscript').forEach(function (n) { n.remove(); });
                return { title: pText || cleanTitle(doc.title), html: wrap.innerHTML };
            }
            if (!sections.length) throw new Error('leer');
            sections.forEach(function (el) { wrap.appendChild(el); });
            wrap.querySelectorAll('script, noscript').forEach(function (n) { n.remove(); });
            Array.prototype.forEach.call(wrap.querySelectorAll(HERO_ACTIONS), function (n) { n.remove(); });
            var title = '';
            /* Beginnt die Seite mit einem eigenen Hero, ist dessen Titel der
               Popup-Titel; Eyebrow und Titel fallen im Popup weg (sonst doppelt),
               Untertitel und Knoepfe des Heros bleiben. */
            var heroTitle = sections[0].querySelector(HERO_TITLE);
            if (heroTitle) {
                title = heroTitle.textContent.trim();
                var hero = heroTitle.parentElement;
                Array.prototype.forEach.call(hero.querySelectorAll(HERO_EYEBROW), function (n) { n.remove(); });
                heroTitle.remove();
                if (!hero.children.length && !hero.textContent.trim()) hero.remove();
            }
            /* Der Seitentitel der Standard-Seite steht schon im Kopf des Popups */
            var head = !title && wrap.querySelector('.shopify-section--main-page .section-header');
            if (head) {
                title = head.textContent.trim();
                head.remove();
            }
            if (!title) {
                var og = doc.querySelector('meta[property="og:title"]');
                title = cleanTitle((og && og.getAttribute('content')) || doc.title);
            }
            return { title: title, html: wrap.innerHTML };
        });
    }

    function open(link) {
        var url = link.href;
        ensureModal();
        /* Prestige stapelt Modal und Drawer nicht in der Top-Layer, sondern ueber
           die DOM-Reihenfolge (beide z-index 999): beim Oeffnen haengt es sie ans
           Ende von <body>, aber nur, wenn sie nicht schon direkt darin liegen.
           Das Popup liegt dauerhaft in <body> und wuerde nie wieder verschoben;
           ein spaeter geoeffneter Warenkorb-Drawer laege dann darueber (nach einem
           Popup aus dem Accordion oder beim zweiten Oeffnen des Drawers). Deshalb
           vor jedem Oeffnen selbst nach hinten - nur geschlossen, ein offenes
           Modal wuerde beim Verschieben seine Fokusfalle und damit sich selbst
           schliessen. */
        if (!modal.open && modal.nextElementSibling) document.body.appendChild(modal);
        current = url;
        var hit = cache[url];
        if (hit) {
            render(hit);
        } else {
            /* Beim ersten Laden kein Linktext als Titel (z. B. "frais de
               livraison"): bekannter Titel aus der Session, sonst leer */
            titleEl.textContent = readTitles()[url] || link.getAttribute('data-cz-popup-title') || '';
            showLoading();
        }
        /* Prestiges Fokusfalle fokussiert nicht in jedem Fall (am Handy nie,
           am Rechner nur mit Hover-Geraet): danach selbst sicherstellen,
           dass der Fokus im Popup liegt — sonst landet die Tastatur dahinter. */
        modal.show().then(function () {
            if (current !== url) return;
            if (!modal.contains(document.activeElement)) titleEl.focus({ preventScroll: true });
        });
        if (hit) return;
        load(url).then(function (data) {
            cache[url] = data;
            storeTitle(url, data.title);
            if (current === url) render(data);
        }).catch(function () {
            if (current === url) window.location.href = url;
        });
    }

    document.addEventListener('click', function (e) {
        if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        var link = e.target.closest && e.target.closest('a[data-cz-popup]');
        if (!link || !link.href || link.origin !== window.location.origin) return;
        if (!window.customElements || !window.customElements.get('x-modal')) return;
        e.preventDefault();
        open(link);
    });
})();
